import React from "react";

// Mismos tokens que HomeBoldSunset.jsx / Navbar.jsx
const COLORS = {
  bg: "#200A08",
  surface: "#341210",
  orange: "#FF7A33",
  gold: "#FFC93C",
  teal: "#2EC4B6",
  ink: "#FBEDE2",
  muted: "#C9A79B",
};

const FONT_DISPLAY = '"Arial Black", "Helvetica Neue", Arial, sans-serif';
const FONT_BODY = 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';
const FONT_MONO = 'ui-monospace, "Cascadia Code", "SFMono-Regular", Menlo, monospace';

const PARAGRAPHS = [
  "Hola, soy Julio Muñoz, un desarrollador web apasionado por la creación de experiencias digitales interactivas y funcionales. Mi interés por la tecnología comenzó hace varios años, cuando descubrí el mundo de la programación y el desarrollo web. Desde entonces, me he dedicado a aprender y perfeccionar mis habilidades en diversas tecnologías como JavaScript, React, Node.js y CSS.",
  "Mi objetivo es crear aplicaciones que no solo sean funcionales, sino también visualmente atractivas y fáciles de usar. Me encanta resolver problemas complejos mediante soluciones elegantes y escalables. Siempre busco estar al tanto de las últimas tendencias en desarrollo web y seguir aprendiendo nuevas herramientas y lenguajes para mejorar mis habilidades.",
  "En mis proyectos pongo especial énfasis en la usabilidad, la accesibilidad y la optimización del rendimiento. Además de mi experiencia técnica, disfruto trabajando en equipo y colaborando en proyectos multidisciplinarios donde puedo aportar ideas creativas y aprender de otros profesionales.",
  "Cuando no estoy programando, me gusta explorar nuevas tecnologías, leer sobre innovación digital y compartir conocimientos con otros desarrolladores. También disfruto de actividades como el senderismo, la fotografía y el cine.",
  "Si estás buscando un desarrollador web entusiasta, detallista y siempre dispuesto a aprender, no dudes en contactarme.",
];

const About = () => {
  return (
    <div style={{ background: COLORS.bg, color: COLORS.ink, fontFamily: FONT_BODY }} className="min-h-screen w-full selection:bg-yellow-300 selection:text-red-900">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        {/* Eyebrow, igual que en el resto del sitio */}
        <p
          style={{ fontFamily: FONT_MONO, color: COLORS.teal, letterSpacing: "0.15em" }}
          className="text-xs md:text-sm uppercase mb-6"
        >
          Quién soy
        </p>

        {/* Título con el mismo bloque de color que el hero de Home */}
        <div className="relative inline-block mb-12">
          <span
            style={{ background: COLORS.orange, transform: "skewY(-2deg)" }}
            className="absolute inset-0 -z-0"
          />
          <h1
            style={{ fontFamily: FONT_DISPLAY, color: COLORS.bg, letterSpacing: "-0.02em" }}
            className="relative z-10 text-4xl md:text-6xl uppercase px-3 py-1"
          >
            Sobre mí
          </h1>
        </div>

        {/* Cuerpo del texto */}
        <div className="space-y-6">
          {PARAGRAPHS.map((p, i) => (
            <p key={i} style={{ color: i === 0 ? COLORS.ink : COLORS.muted }} className="text-base md:text-lg leading-relaxed">
              {p}
            </p>
          ))}
        </div>

        {/* Línea de cierre / firma, acento gold */}
        <div style={{ borderTop: `1px solid ${COLORS.surface}` }} className="mt-12 pt-6 flex items-center gap-3">
          <span style={{ width: 32, height: 2, background: COLORS.gold }} />
          <span style={{ fontFamily: FONT_MONO, color: COLORS.gold }} className="text-xs uppercase tracking-wide">
            Julio Muñoz — Full Stack Developer
          </span>
        </div>
      </div>
    </div>
  );
};

export default About;